import { ArrowForwardRounded } from '@material-ui/icons';
import { useStyles } from '@webapps/styles';
import { uploadCerfa } from '@webapps/business';
import { useMutation, useToast } from '@webapps/reactjs-tech-components';
import { useEffect } from 'react';
import { CircularProgress } from '@material-ui/core';

const InformationSend = ({ opcoRecord, refetch }) => {
  const { classes, css, cx, global } = useStyles(styles);

   const { addToast } = useToast();

  const {
    error: errorUploadCerfa,
    isLoading: isLoadingUploadCerfa,
    isSuccess: isSuccessUploadCerfa,
    mutateAsync: mutateUploadCerfa,
  } = useMutation(uploadCerfa);

  useEffect(() => {
    if (isSuccessUploadCerfa) {
      addToast({
        status: 'success',
        message: 'Le dossier est en cours de synchronisation. Une notification vous sera envoyée dès que le traitement sera terminé.',
      });
      refetch()
    } else if (errorUploadCerfa) {
      addToast({
        status: 'error',
        message: `Une erreur est survenue lors de la synchronisation du dossier: ${errorUploadCerfa?.response?.data?.description || ''}`,
      });
    }
  }, [errorUploadCerfa, isSuccessUploadCerfa]);

  return !isSuccessUploadCerfa ? (
    <div className={cx(global.fcjc, classes.information, { [classes.disabled]: isLoadingUploadCerfa })} onClick={() => !isLoadingUploadCerfa && mutateUploadCerfa({ id: opcoRecord?.id })} aria-disabled={isLoadingUploadCerfa}>
      <div className={global.frac} style={{ gap: 8 }}>
        <div className={classes.contractSpan}>DOSSIER COMPLET</div>
        <h1 className={global.title} style={{ margin: 0 }}>Déposer le dossier auprès de l'OPCO ({opcoRecord?.businessEmployer?.opco})</h1>
        {isLoadingUploadCerfa ? (
          <CircularProgress size={12} style={{ color: '#0060F9' }} />
        ) : (
          <ArrowForwardRounded style={{ color: '#0060F9', fontSize: 12 }} />
        )}
      </div>
      <div className={classes.kawaiiText}>Synchroniser votre dossier auprès de l'OPCO pour y assurer son suivi</div>
    </div>
  ) : null;
};

const styles = ({ fontSizes, spacing }) => ({
  information: {
    backgroundColor: "#C0D9FF",
    cursor: "pointer",
    gap: 8,
    padding: 20,
    borderRadius: 10,
    "&:hover h1": {
      color: "#0060F9",
    },
  },
  disabled: {
    transition: 'all 0.3s ease',
    filter: 'grayscale(100%)',
    cursor: 'not-allowed',
    '&:hover h1': {
      color: '#152652',
    },
  },
  contractSpan: {
    backgroundColor: "#0060F9",
    borderRadius: '5px',
    padding: '0px 5px',
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '12px',
    color: "white"
  },
  kawaiiText: {
    fontSize: 12,
  }
});

export default InformationSend;